import { render, staticRenderFns } from "./CopyCityList.vue?vue&type=template&id=966a8602&scoped=true&"
import script from "./CopyCityList.vue?vue&type=script&lang=js&"
export * from "./CopyCityList.vue?vue&type=script&lang=js&"
import style0 from "./CopyCityList.vue?vue&type=style&index=0&id=966a8602&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966a8602",
  null
  
)

export default component.exports